import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var c=create((o,i)=>({...a(o,i),msg:"",show(s){let{isActive:r}=i();r||o({isActive:!0,msg:s});}}));

export { c as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-BRVQHXJT.mjs.map